import script from "./StarButton.vue?vue&type=script&lang=js"
export * from "./StarButton.vue?vue&type=script&lang=js"

export default script